<div class="dialog-container">
  <div class="header">
    <h2 mat-dialog-title class="subheading" id="subheading">{{ subheading() }}</h2>
  </div>

  <mat-dialog-content>
    <div class="form-field">
      <label class="field-label" id="report-type-label">{{ reportTypeLabel() }}</label>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-select
          id="report-type"
          [(ngModel)]="selectedReportType"
          [value]="selectedReportType()">
          <mat-option *ngFor="let option of reportTypeOptions()" [value]="option.value">
            {{ option.text }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-field full-width">
      <label class="field-label" id="text-area-label">{{ justificationLabel() }}</label>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <textarea
          matInput
          id="text-area"
          [(ngModel)]="justification"
          rows="5"
          placeholder="Enter your justification here..."></textarea>
      </mat-form-field>
      @if (errorMessage()) {
        <div class="error-message" id="error-message">{{ errorMessage() }}</div>
      }
    </div>

    <div class="footer-note" id="footer-note">
      * {{ footerNote() }}
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      mat-button
      class="cancel-button"
      (click)="cancelAction()">
      {{ cancelText() }}
    </button>
    <button
      mat-raised-button
      class="confirm-btn"
      (click)="confirmAction()">
      {{ confirmText() }}
    </button>
  </mat-dialog-actions>
</div>
